<template>
    <div>
        <h5 class="mt-4 mb-3">{{ $t('GradeControl.TimesheetsSummary.Title') }}</h5>
        <table>
            <thead>
                <tr class="mainHeader">
                    <th></th>
                    <th colspan="5">{{ muckSummaryTitle }}</th>
                    <th colspan="5">{{ haulingSummaryTitle }}</th>
                    <th colspan="5">{{ remuckSummaryTitle }}</th>
                    <th colspan="5">{{ $t('GradeControl.TimesheetsSummary.Total') }}</th>
                </tr>
                <tr class="subHeader">
                    <th></th>
                    
                    <th>{{wasteSummaryTitle}}</th>
                    <th>{{oreSummaryTitle}}</th>
                    <th>{{acidSummaryTitle}}</th>
                    <th>{{standbySummaryTitle}}</th>
                    <th>{{ $t('GradeControl.TimesheetsSummary.Total') }}</th>

                    <th>{{wasteSummaryTitle}}</th>
                    <th>{{oreSummaryTitle}}</th>
                    <th>{{acidSummaryTitle}}</th>
                    <th>{{standbySummaryTitle}}</th>
                    <th>{{ $t('GradeControl.TimesheetsSummary.Total') }}</th>

                    <th>{{wasteSummaryTitle}}</th>
                    <th>{{oreSummaryTitle}}</th>
                    <th>{{acidSummaryTitle}}</th>
                    <th>{{standbySummaryTitle}}</th>
                    <th>{{ $t('GradeControl.TimesheetsSummary.Total') }}</th>

                    <th>{{wasteSummaryTitle}}</th>
                    <th>{{oreSummaryTitle}}</th>
                    <th>{{acidSummaryTitle}}</th>
                    <th>{{standbySummaryTitle}}</th>
                    <th>{{ $t('GradeControl.TimesheetsSummary.Total') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="index" class="dataRows">
                    <td width="200px" class="whitespace-no-wrap">
                        {{ item.title }}
                    </td>

                    <td>{{item.muck.sterile | toFixedIfDecimal}}</td>
                    <td>{{item.muck.ore | toFixedIfDecimal}}</td>
                    <td>{{item.muck.acid | toFixedIfDecimal}}</td>
                    <td>{{item.muck.standby | toFixedIfDecimal}}</td>
                    <td class="font-medium">{{ item.muck.total  | toFixedIfDecimal}}</td>

                    <td>{{item.hauling.sterile | toFixedIfDecimal}}</td>
                    <td>{{item.hauling.ore | toFixedIfDecimal}}</td>
                    <td>{{item.hauling.acid | toFixedIfDecimal}}</td>
                    <td>{{item.hauling.standby | toFixedIfDecimal}}</td>
                    <td class="font-medium">{{ item.hauling.total  | toFixedIfDecimal}}</td>

                    <td>{{item.remuck.sterile | toFixedIfDecimal}}</td>
                    <td>{{item.remuck.ore | toFixedIfDecimal}}</td>
                    <td>{{item.remuck.acid | toFixedIfDecimal}}</td>
                    <td>{{item.remuck.standby | toFixedIfDecimal}}</td>
                    <td class="font-medium">{{ item.remuck.total | toFixedIfDecimal}}</td>

                    <td>{{item.total.sterile | toFixedIfDecimal}}</td>
                    <td>{{item.total.ore | toFixedIfDecimal}}</td>
                    <td>{{item.total.acid | toFixedIfDecimal}}</td>
                    <td>{{item.total.standby | toFixedIfDecimal}}</td>
                    <td class="font-medium">{{ item.total.total | toFixedIfDecimal}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import TimesheetOperationTypeEnum from "../../TimesheetOperationTypeEnum";
import MaterialTypeEnum from "../../MaterialTypeEnum";
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },

  computed: {
    muckSummaryTitle() {
      return TimesheetOperationTypeEnum.getNameFor(TimesheetOperationTypeEnum.Muck);
    },
    haulingSummaryTitle() {
      return TimesheetOperationTypeEnum.getNameFor(TimesheetOperationTypeEnum.Hauling);
    },
    remuckSummaryTitle() {
      return TimesheetOperationTypeEnum.getNameFor(TimesheetOperationTypeEnum.Remuck);
    },
    wasteSummaryTitle() {
      return MaterialTypeEnum.getNameFor(MaterialTypeEnum.Sterile);
    },
    oreSummaryTitle() {
      return MaterialTypeEnum.getNameFor(MaterialTypeEnum.Ore);
    },
    acidSummaryTitle() {
      return MaterialTypeEnum.getNameFor(MaterialTypeEnum.Acid);
    },
    standbySummaryTitle() {
      return MaterialTypeEnum.getNameFor(MaterialTypeEnum.Standby);
    }
  }
}
</script>
<style lang="scss" scoped>
    // Width stuff
    div {
        width: 100%;
        overflow-x: auto;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    
    // Header styling stuff
    .mainHeader {
        font-size: 0.8rem;
        font-weight: 600;
        color: #4a5568;
    }

    .subHeader {
        font-size: 0.8rem;
        font-weight: 600;
        color: #4a5568;
    }

    // Border stuff
    .subHeader th:not(:first-child) {
        border-bottom: 1px solid #e2e8f0;
    }

    .dataRows td:not(:first-child) {
        padding: 0.5rem 0.75rem;
        font-size: 0.8rem;
        color: #4a5568;
    }

    td:nth-child(5n-4),
    .subHeader th:nth-child(5n-4),
    .mainHeader th {
        border-right: 1px solid #e2e8f0;
    }

    // Background color stuff
    .dataRows:nth-child(odd) {
        background-color: #f7fafc;
    }
</style>